const items = {
  "languages.en-US": "English",
  "languages.zh-Hans": "简体中文",
  "languages.zh-Hant": "繁體中文",
  "languages.fr": "Français",
  "languages.es": "Español",
  "languages.ja": "日本語",
  "languages.ko": "한국어",
  "languages.my": "Myanmar",
  "languages.vi": "越南语",
};

export default items;
